import { Styles, buttonBaseClasses, generateClasses, sidebarClasses, sidebarMenuItemClasses } from 'netline-ui';
import getAppFrameTheme from 'utils/theme';

export const sidebarNavigationClasses = generateClasses('SidebarNavigation', ['root'] as const);

const styles: Styles = ({ theme, theme: { zIndex, palette } }) => {
  const {
    sidebar: { hidden },
  } = getAppFrameTheme(theme);

  return {
    [`&&.${sidebarNavigationClasses.root}`]: {
      ...(hidden ? { display: 'none' } : {}),
      [`.${sidebarClasses.sidebar}`]: {
        // Remove when netline-ui provides this change
        paddingTop: 0,
        zIndex: Math.round(Math.ceil((zIndex.appBar + zIndex.drawer) / 2)), // 1150
      },
      [`.${sidebarMenuItemClasses.root}`]: {
        color: palette.grey[600],
        [`.${sidebarMenuItemClasses.menuItem}.active`]: {
          color: palette.common.white,
        },
      },
      [`.${buttonBaseClasses.root}`]: {
        outline: 'none',
      },
    },
  };
};

export default styles;
